<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.template_group_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.templateGroupsCreate"
    [queryParams]="{returnTo: util.getPageLink()}"
    sbTooltip="{{ 'lang.globals.templateGroup.create' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.templateGroups' | translate}}"
  [isInModalContext]="isInModalContext"
  [itemsData]="templateGroups"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'templateGroups'">

  <!------------------------------

      Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.created' | translate }}
      </th>
      <th>
        {{ 'lang.globals.templateVariables' | translate }}
      </th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-data>

    <tr>
      <td>
        {{ data?.id }}
      </td>
      <td>
        <sb-comp-link
          [title]="data?.name"
          [condition]="!isInModalContext"
          [permission]="permissionService.Permission.template_group_list"
          [link]="util.RoutingID.templateGroupsEdit"
          [pathParams]="[{id: 'templateGroupID',value: data?.id}]"
          [tooltip]="'lang.globals.details' | translate">
        </sb-comp-link>
      </td>
      <td>
        <sb-comp-display-created [data]="data"></sb-comp-display-created>
      </td>
      <td>
        {{ data?.variables?.length }}
      </td>
      <td class="tr bw sticky-col last-col">
        @if (!isInModalContext) {
          <sb-split-button
            [splitButtonItems]="data.sbButtons ?? []">
          </sb-split-button>
        } @else {
          <button
            sb-button-secondary
            type="button"
            [ngbTooltip]="'lang.globals.select' | translate"
            (click)="selectTemplateGroup(data)"
            [icon]="'boxChecked'"
            [color]="'blue'"
            [iconButton]="true">
          </button>
        }
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
